<template>
  <div
    :style="{
      height: showHeight,
      overflowY: 'auto',
      overflowX: 'hidden',
    }"
  >
    <el-form
      ref="formData"
      :model="formData"
      :rules="rules"
      class="mr-2"
      size="small"
    >
      <el-row :gutter="20">
        <el-col>
          <el-form-item
            :label="$l('table_label_location_no') || '库位编号'"
            prop="locationNo"
          >
            <el-input
              v-model="formData.locationNo"
              :disabled="!!formData.locationCode"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col>
          <el-form-item
            :label="$l('table_label_location_description') || '库位描述'"
          >
            <el-input
              v-model="formData.locationDescription"
              :disabled="disabled"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col>
          <el-form-item
            :label="$l('form_label_locationFullName') || '库位全称'"
          >
            <el-input v-model="formData.locationFullName" readonly />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_locType') || '库位类型'"
            prop="locType"
          >
            <dict-select
              v-model="formData.locType"
              url="/sys/common/dict/system"
              :body="{ dictType: 'locType' }"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              :disabled="disabled"
              filterable
              clearable
              style="width:100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_locSellType') || '库位售卖类型'"
            prop="locSellType"
          >
            <dict-select
              v-model="formData.locSellType"
              url="/sys/common/dict/system"
              :body="{ dictType: 'locSellType' }"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              :disabled="disabled"
              filterable
              clearable
              style="width:100%"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="$l('table_label_is_last') || '是否末级'"
            prop="isLast"
          >
            <el-select
              v-model="formData.isLast"
              :disabled="disabled || disabledLast"
              style="width:100%"
            >
              <el-option
                :label="$l('form_label_is_last_yes') || '是'"
                value="Y"
              />
              <el-option
                :label="$l('form_label_is_last_no') || '否'"
                value="N"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$l('table_label_class_level') || '层级'">
            <el-input v-model="formData.classLevel" readonly />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$l('form_label_create_by') || '创建人'">
            <el-input
              v-model="formData.createByName"
              :placeholder="$l('INDEX.form_label_automatic_system_generation')"
              readonly
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$l('form_label_create_date') || '创建时间'">
            <el-input
              v-model="formData.createDate"
              :placeholder="$l('INDEX.form_label_automatic_system_generation')"
              readonly
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$l('form_label_modify_by') || '修改人'">
            <el-input
              v-model="formData.modifyByName"
              :placeholder="$l('INDEX.form_label_automatic_system_generation')"
              readonly
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$l('form_label_modify_date') || '修改时间'">
            <el-input
              v-model="formData.modifyDate"
              :placeholder="$l('INDEX.form_label_automatic_system_generation')"
              readonly
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="d-flex justify-content-end mt-2 mb-2">
      <el-button v-if="!disabled" type="primary" size="small" @click="save()">
        {{ $l('INDEX.btn_save') || '保存' }}
      </el-button>
    </div>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import store from '../../store'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  data() {
    return {
      disabled: true,
      disabledLast: true,
      isEditMode: true,
      formData: {},
      rules: {
        locationNo: [
          {
            required: true,
            message: this.$l('table_label_pe_location_no') || '请输入库位编号',
            trigger: 'blur',
          },
        ],
        locType: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'blur',
          },
        ],
        locSellType: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'blur',
          },
        ],
      },
      showHeight: '500px',
    }
  },
  computed: {
    selected() {
      return store.state.selected
    },
  },
  watch: {
    selected() {
      this.getData()
    },
  },
  created() {
    window.addEventListener('resize', this.getHeight)
    this.getHeight()
  },
  destroyed() {
    window.removeEventListener('resize', this.getHeight)
  },
  methods: {
    getHeight() {
      this.showHeight = window.innerHeight - 234 + 'px'
    },
    getData() {
      this.disabled = true
      if (!this.selected || !this.selected.locationCode) return
      if (this.selected.classLevel == 0 || this.selected.classLevel == 1) {
        this.$api
          .masterLocationDetailApi({
            locationCode: this.selected.locationCode,
          })
          .then((res) => {
            if (res.body) {
              this.formData = res.body
            }
          })
      } else if (this.selected.classLevel == -1) {
        this.$api
          .masterLocationWarehouseDetailApi({
            locationCode: this.selected.locationCode,
          })
          .then((res) => {
            this.formData = res.body
          })
      }
    },
    openEdit() {
      if (this.selected.classLevel == -1) {
        this.$message.warning(
          this.$l('edit_warehouse_error') || '库房信息不能被编辑'
        )
        return
      }
      if (this.selected.classLevel == 0 || this.selected.classLevel == 1) {
        this.disabled = false
        this.disabledLast = this.selected.classLevel == 1
        this.isEditMode = true
      }
    },
    openAdd() {
      if (this.selected.isLast == 'Y') {
        this.$message.warning(
          this.$l('form_label_tip_location_current') || '注意已经是末级！'
        )
        return
      }
      if (this.selected.locationStatus == 'N') {
        this.$message.warning(
          this.$l('form_label_tip_location_status') || '请选择有效库位'
        )
        return
      }
      this.formData.locationNo = ''
      this.formData.locationDescription = ''
      this.formData.locationStatus = 'Y'
      this.formData.createByName = ''
      this.formData.createDate = ''
      this.formData.locationCode = ''
      this.formData.modifyByName = ''
      this.formData.modifyDate = ''
      this.formData.parentCode = this.selected.locationCode
      this.formData.classLevel = this.selected.classLevel - 0 + 1
      this.formData.isLast = 'Y'
      this.formData.parentName = this.selected.locationDescription
      this.disabled = false
      this.disabledLast = this.selected.classLevel == 0
      this.isEditMode = false
    },
    save() {
      const result = validate.formValidate([this.$refs.formData])
      if (!result) {
        return
      }
      this.loadingOpen()
      this.$api
        .masterLocationSaveApi(this.formData)
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success',
          })
          if (this.isEditMode)
            //更新状态
            this.selected.isLast = this.formData.isLast
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    openDel() {
      if (!this.selected || !this.selected.locationCode) {
        this.$message.warning(
          this.$l('form_label_tip_location') || '请选择一个库位'
        )
        return
      }
      if (this.selected.classLevel == -1 || this.selected.isLast == 'N') {
        //this.selected.classLevel == 0
        this.$message.warning(
          this.$l('form_label_tip_location_last') || '请选择末级库位！'
        )
        return
      }
      if (this.selected.locationStatus == 'N') {
        this.$message.warning(
          this.$l('form_label_tip_location_status') || '请选择有效库位'
        )
        return
      }

      this.$confirm(
        this.$l('INDEX.tips_delete') || '确认要删除该记录吗？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => {
          this.loadingOpen()
          this.$api
            .masterLocationDelApi({ locationCode: this.selected.locationCode })
            .then((res) => {
              this.loadingClose()
              this.$message({
                showClose: true,
                message: this.$l('INDEX.tips_delete_ok') || res.msg,
                type: 'success',
              })
              this.formData.locationStatus = 'N' // 更新状态
              this.selected.locationStatus = 'N'
            })
        })
        .catch(() => {
          this.loadingClose()
        })
    },
  },
}
</script>
